<template>
	<div class="sampleA">
		<p class="sampleA_header">
			<router-link to="questionSetting?id=5" tag="div" class="back">
				<i class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></i>
				<span>返回</span>
			</router-link>
			<span>样本指派</span>
		</p>

		<div class="main">
			<el-tabs v-model="tab">
				<el-tab-pane label="样本指派" name="first">
					<div class="sampleA_content">
						<div class="sampleA_content_a">
							<p>
								<span></span>
								选择指派人员
							</p>
							<div class="sampleA_content_a_box">
								<p>搜索已分配访员</p>
								<label>
									<el-input v-model="names" placeholder="搜索用户名"></el-input>
									<i></i>
								</label>
								<el-tree :data="filterSampleA_data_by_name" :props="defaultProps">
									<span @click="addAssigned(data)" class="custom-tree-node" slot-scope="{ node, data }">
										<span>{{ data.username || data.nickname || data.loginname }}</span>
										<span style="float: right;padding-right: 30px;">({{ data.countNum }})</span>
									</span>
								</el-tree>
							</div>
							<div class="page"></div>
						</div>
						<div class="sampleA_content_b">
							<div class="b_header">
								<div class="b_header_left">
									<span></span>
									选择被指派样本
								</div>
								<div class="b_header_right">
									<label>
										用户名:
										<el-input v-model="name" @change="pageTableBy(name, phone, sampleId)"></el-input>
									</label>
									<label>
										手机号:
										<el-input v-model="phone" @change="pageTableBy(name, phone, sampleId)"></el-input>
									</label>
									<label>
										<el-input v-model="sampleId" @change="pageTableBy(name, phone, sampleId)" placeholder="搜索样本编号"></el-input>
										<i></i>
									</label>
								</div>
							</div>
							<!-- table -->
							<el-table
								class="sampleA_content_b_table"
								ref="multipleTable"
								:data="ampleATableData"
								tooltip-effect="dark"
								border="border"
								size="mini"
								header-row-class-name="thead-cell"
								@selection-change="handleSelectionChange"
							>
								<el-table-column type="selection" width="40" fixed="left"></el-table-column>
								<el-table-column prop="answerName" label="用户名" width="110"></el-table-column>
								<el-table-column prop="id" label="样本编号" width="175"></el-table-column>

								<el-table-column prop="email" label="邮箱" width="180"></el-table-column>
								<el-table-column prop="cellPhone" label="手机号" width="120"></el-table-column>
								<el-table-column prop="answerSex" label="性别" width="56"></el-table-column>
								<el-table-column prop="answerAge" label="年龄" width="56"></el-table-column>
								<el-table-column prop="maritalStatus" label="婚姻状态" width="90"></el-table-column>
								<el-table-column prop="answerAddress" label="详细地址" width="120" :show-overflow-tooltip="!0"></el-table-column>
								<el-table-column prop="position" label="职位" width="100"></el-table-column>
								<el-table-column prop="answerState" label="状态" width="130"></el-table-column>
								<el-table-column label="操作" width="130" fixed="right">
									<template slot-scope="scope">
										<el-button type="primary" @click="looksampleM(scope.row)" round size="mini">查看样本</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination
								@current-change="CurrentChange1"
								:hide-on-single-page="page_value"
								:current-page.sync="one_page.currentPageIndex"
								:page-size="one_page.pageSize"
								:total="one_page.totals"
								class="fr"
								background
								layout="prev, pager, next"
							></el-pagination>
							<el-button class="fl" @click="canceldistributionsample(1)">分配</el-button>
						</div>
					</div>
				</el-tab-pane>
				<!-- 已指派样本                               ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ -->
				<el-tab-pane label="已指派样本" name="second">
					<div class="sampleA_content">
						<div class="sampleA_content_a">
							<p>
								<span></span>
								已指派人员
							</p>
							<div class="sampleA_content_a_box">
								<p>已指派人员</p>
								<label>
									<el-input v-model="names" placeholder="搜索用户名"></el-input>
									<i></i>
								</label>
								<el-tree :data="sampleC_data" :props="defaultProps">
									<span @click="addAssigned(data)" class="custom-tree-node" slot-scope="{ node, data }">
										<span>{{ data.username || data.nickname || data.loginname }}</span>
										<span style="float: right;padding-right: 30px;">({{ data.countNum }})</span>
									</span>
								</el-tree>
							</div>
							<div class="page"></div>
						</div>
						<div class="sampleA_content_b">
							<div class="b_header">
								<div class="b_header_left">
									<span></span>
									已选样本
								</div>
							</div>
							<!-- table -->
							<el-table
								class="sampleA_content_b_table"
								ref="multipleTable"
								:data="ampleATableData2"
								tooltip-effect="dark"
								border="border"
								size="mini"
								header-row-class-name="thead-cell"
								@selection-change="handleSelectionChange"
							>
								<el-table-column type="selection" width="40" fixed="left"></el-table-column>
								<el-table-column prop="answerName" label="用户名" width="110"></el-table-column>
								<el-table-column prop="id" label="样本编号" width="175"></el-table-column>

								<el-table-column prop="email" label="邮箱" width="180"></el-table-column>
								<el-table-column prop="cellPhone" label="手机号" width="120"></el-table-column>
								<el-table-column prop="answerSex" label="性别" width="56"></el-table-column>
								<el-table-column prop="answerAge" label="年龄" width="56"></el-table-column>
								<el-table-column prop="maritalStatus" label="婚姻状态" width="90"></el-table-column>
								<el-table-column prop="answerAddress" label="详细地址" width="120" :show-overflow-tooltip="!0"></el-table-column>
								<el-table-column prop="position" label="职位" width="100"></el-table-column>
								<el-table-column prop="answerState" label="状态" width="130"></el-table-column>
								<el-table-column label="操作" width="130" fixed="right">
									<template slot-scope="scope">
										<el-button type="primary" @click="looksampleM(scope.row)" round size="mini">查看样本</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination
								@current-change="CurrentChange2"
								:hide-on-single-page="page_value"
								:current-page.sync="three_page.currentPageIndex"
								:page-size="three_page.pageSize"
								:total="three_page.totals"
								class="fr"
								background
								layout="prev, pager, next"
							></el-pagination>
							<el-button class="fl" @click="canceldistributionsample(2)">取消分配</el-button>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<!-- 模态框  遮罩层-->
		<div v-if="modalBox" class="modalBox"></div>
		<div class="sampleMBox" v-if="sampleMBox">
			<p>
				<span @click="tosampleM">
					<i class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></i>
					返回样本配置
				</span>
				<span>样本编号:{{ sampleMBox_id }}</span>
			</p>
			<div class="sampleMBox_label">
				<label>
					用户名:
					<el-input type="text" v-model="sampleMBox_name" />
				</label>
				<!-- 	<label>
					身份证:
					<el-input type="text" v-model="sampleMBox_add"/>
				</label> -->
				<label>
					性别 :
					<el-input type="text" v-model="sampleMBox_sex" />
				</label>
				<label>
					年龄 :
					<el-input type="text" v-model="sampleMBox_age" />
				</label>
				<label>
					生日 :
					<el-input type="text" v-model="sampleMBox_day" />
				</label>
				<label>
					邮箱 :
					<el-input type="text" v-model="sampleMBox_email" />
				</label>
				<label>
					手机 :
					<el-input type="text" v-model="sampleMBox_phone" />
				</label>
				<label>
					婚姻 :
					<el-input type="text" v-model="sampleMBox_marital" />
				</label>
				<!-- <label>
					学历 :
					<el-input type="text" v-model="sampleMBox_xueli"/>
				</label> -->
				<label>
					职位 :
					<el-input type="text" v-model="sampleMBox_zhiwei" />
				</label>
				<!-- <label>
					公司 :
					<el-input type="text" v-model="sampleMBox_gonsi"/>
				</label> -->
				<br />
				<label>
					地址&ensp;:
					<el-input type="text" v-model="sampleMBox_dizhi" />
				</label>

				<label v-for="(item, index) in extendSampleDetaList" :key="index">
					{{ item.namme }}:
					<el-input type="text" v-model="item.content" />
				</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tab: 'first',
			// 详细信息
			extendSampleDetaList: [],
			delSampleMBoxId: '',
			sampleMBox_id: '',
			sampleMBox_name: '',
			sampleMBox_add: '',
			sampleMBox_sex: '',
			sampleMBox_age: '',
			sampleMBox_day: '',
			sampleMBox_email: '',
			sampleMBox_phone: '',
			sampleMBox_marital: '',
			sampleMBox_xueli: '',
			sampleMBox_zhiwei: '',
			sampleMBox_gonsi: '',
			sampleMBox_dizhi: '',
			// sampleMBox:{

			// },
			// 模态框 遮罩层
			modalBox: false,
			sampleMBox: false,
			// 选择样本和指派对象

			// 指派对象
			assign: {},

			sampleContrastIdList: [],

			page_value: false,
			// input 的v-model
			input6: '',
			input5: '',
			sampleId: '',
			questionnaireid: '', //搜索样本编号
			phone: '', //搜索手机号
			name: '', //搜索用户名
			names: '', //全部用户的搜索
			// table
			idList: [],
			ampleATableData2: [], //表格数据 分配之后
			ampleATableData: [], //表格数据 初始化时
			sampleA_data: [], //查询用户 没传名字的时候
			defaultProps: {
				children: 'children',
				label: 'loginname',
				number: 'number',
				username: 'username'
			},
			one_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10 //一页显示几个
			},
			three_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10 //一页显示几个
			}
		};
	},
	computed: {
		filterSampleA_data_by_name() {
			return this.sampleA_data.filter(item => item.username.indexOf(this.names) > -1 || item.nickname.indexOf(this.names) > -1);
		},
		sampleC_data() {
			return this.sampleA_data.filter(item => item.countNum > 0);
			console.log();
		}
	},
	mounted: function() {
		this.pageTableBy(); //指派表格
		this.queryassignpeople();
	},
	methods: {
		// 分配 人员
		canceldistributionsample(state) {
			let wid = sessionStorage.getItem('wid');
			let sampleContrastIdList = this.sampleContrastIdList;
			this.idList = [];
			for (let i = 0; i < sampleContrastIdList.length; i++) {
				this.idList.push(sampleContrastIdList[i].id);
			}
			let params = {
				url: this.$config.service.canceldistributionsample,
				method: 'post',
				data: {
					assignId: this.assign.userId,
					operationStatus: state,
					sampleContrastIdList: this.idList
				},
				that: this,
				cb: res => {
					if (res.code == 0) {
						console.log('res', res);
						this.pageTableBy();

						this.pageTableBy2();
						this.queryassignpeople();
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		// 选择指派人员
		queryassignpeople(names) {
			let that = this;
			let wid = sessionStorage.getItem('wid');
			this.$api
				.QueryAssignInterviewUser(1, 10, wid, names)
				.then(data => {
					this.sampleA_data = data.resultBody.datas;
				})
				.catch(error => {
					console.log(error);
				});
		},

		// 表格 选择被指派样本和搜索
		pageTableBy(name, phone, sampleId) {
			let that = this;
			let wid = sessionStorage.getItem('wid'); //问卷id
			let params = {
				that: this,
				url: `${this.$config.service.querysampledatapage}?pageIndex=${that.one_page.currentPageIndex}&pageSize=${that.one_page.pageSize}`,
				method: 'post',
				data: {
					questionnaireId: wid,
					// 查询
					answerName: name,
					cellPhone: phone,
					sampleId: sampleId
				},
				cb(res) {
					if (res.code == 0) {
						console.log('表格的数据', res.resultBody.datas);
						// 所有数据

						let status_code = ['初始样本', '进行中', '读取', '中断', '无效答卷', '配额已满', '正常结束'];
						for (let i = 0; i < res.resultBody.datas.length; i++) {
							var a = res.resultBody.datas[i].answerState;
							res.resultBody.datas[i].answerState = status_code[a];
						}
						that.ampleATableData = res.resultBody.datas;

						// 一共多少条数据
						that.one_page.totals = res.resultBody.total;
						that.one_page.name = '';
						that.one_page.phone = '';
						that.sampleId = '';
					} else {
						that.ampleATableData = [];
						// console.log('失败 列表数据');
					}
				}
			};
			this.$util.request(params);
		},
		// 分配了的表格数据
		pageTableBy2() {
			let that = this;
			let wid = sessionStorage.getItem('wid'); //问卷id
			let userId = this.assign.userId;
			let params = {
				that: this,
				url: `${this.$config.service.querysampledatapage}?pageIndex=${that.three_page.currentPageIndex}&pageSize=${that.three_page.pageSize}`,
				method: 'post',
				data: {
					questionnaireId: wid,
					userId: userId
				},
				cb(res) {
					if (res.code == 0) {
						console.log('表格2的数据', res.resultBody.datas);
						// 所有数据

						let status_code = ['初始样本', '进行中', '读取', '中断', '无效答卷', '配额已满', '正常结束'];
						for (let i = 0; i < res.resultBody.datas.length; i++) {
							var a = res.resultBody.datas[i].answerState;
							res.resultBody.datas[i].answerState = status_code[a];
						}
						that.ampleATableData2 = res.resultBody.datas;

						// 一共多少条数据
						that.three_page.totals = res.resultBody.total;
						that.three_page.name = '';
						that.three_page.phone = '';
						that.sampleId = '';
					} else {
						that.ampleATableData2 = [];
						console.log('失败 列表数据');
					}
				}
			};
			this.$util.request(params);
		},

		// 表格 checkbox
		handleSelectionChange(val) {
			this.sampleContrastIdList = val;
		},
		// 搜索
		handleNodeClick() {
			console.log();
		},
		// 分页
		// handleSizeChangesmp(val) {
		// 	CurrentChange1(val);
		// 	CurrentChange2(val)
		// },
		// 上一页 下一页
		CurrentChange1(val) {
			let that = this;
			that.one_page.currentPageIndex = val;
			that.pageTableBy();
		},
		CurrentChange2(val) {
			console.log(val);
			let that = this;
			that.three_page.currentPageIndex = val;
			that.pageTableBy2();
		},

		// 分配指派对象
		addAssigned(data) {
			this.assign = data;
			// this.$message.success('选择成功');
			console.log('111', this.assign.userId);
			this.pageTableBy2();
		},
		// 选择指派人员
		inquire(item) {
			console.log('查询', item);
			console.log(item.userId);
			this.assign.userId = item.userId;
			// this.$message.success('11选择成功');
			this.pageTableBy();
		},
		// 返回
		tosampleM() {
			this.modalBox = false;
			this.sampleMBox = false;
		},

		looksampleM(row) {
			//查看样本
			console.log(row);
			this.sampleMBox_id = row.id;
			this.sampleMBox_name = row.answerName;
			this.sampleMBox_add = row.answerAddress;
			this.sampleMBox_sex = row.answerSex;
			this.sampleMBox_age = row.answerAge;
			this.sampleMBox_day = '';
			this.sampleMBox_email = row.email;
			this.sampleMBox_phone = row.cellPhone;
			this.sampleMBox_marital = row.maritalStatus;
			this.sampleMBox_xueli = '';
			this.sampleMBox_zhiwei = row.position;
			this.sampleMBox_gonsi = '';
			this.sampleMBox_dizhi = row.answerAddress;
			this.modalBox = true;
			this.sampleMBox = true;
		}
	}
};
</script>

<style lang="scss">
.sampleA {
	width: 100%;
	min-height: 100%;
	background-color: #f5f5f5;

	.main {
		width: 1280px;
		margin: 0 auto;
	}

	// 头部
	.sampleA_header {
		height: 68px;
		background-color: #fff;
		text-align: center;
		line-height: 68px;
		position: relative;

		.back{
			display: inline-block;
			position: absolute;
    		left: 0;
			span{
				display: inline-block;
			}
		}
		i {
			float: left;
			margin-left: 30px;
			font-size: 16px;
		}
		span {
			font-size: 16px;
			color: #333;
		}
	}
	.sampleA_bread {
		max-width: 1600px;
		height: 69px;
		line-height: 69px;
		color: #333333;
		font-size: 16px;
		margin: auto;
	}
	.sampleA_content {
		max-width: 1600px;
		background-color: #fff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		min-height: 550px;
		.sampleA_content_a {
			min-width: 220px;
			margin: 0px 24px;
			p {
				height: 85px;
				line-height: 85px;
				font-size: 16px;
				color: #333333;
				span {
					height: 16px;
					border: 3px solid #0080ff;
					border-radius: 8px;
					margin-right: 7px;
				}
			}
			.sampleA_content_a_box {
				height: 450px;
				border: 1px solid #e7e7e7;
				p {
					height: 42px;
					padding-left: 10px;
					color: #333;
					font-size: 14px;
					line-height: 42px;
					background-color: #f5f5f5;
				}
				.el-tree {
					height: 368px;
					overflow-y: auto;
					.custom-tree-node {
						width: 220px;
					}
				}
			}
		}
		.sampleA_content_b {
			margin-right: 25px;
			flex: 1;
			width: 0;
			.b_header {
				height: 85px;
				line-height: 85px;
				font-size: 16px;
				color: #333333;
				display: flex;
				justify-content: space-between;
				.b_header_left {
					span {
						height: 16px;
						border: 3px solid #0080ff;
						border-radius: 8px;
						margin-right: 7px;
					}
				}
				.b_header_right {
					display: flex;
					label {
						margin-left: 18px;
						.el-input {
							width: 120px;
							height: 32px;
						}
					}
					label:nth-child(3) {
						margin-left: 15;
						.el-input {
							width: 310px;
						}
					}
				}
			}
			.sampleA_content_b_table {
				margin-bottom: 21px;
				.thead-cell > th {
					background-color: #f5f5f5;
					.cell {
						text-align: center;
					}
				}
				.el-table__row > td {
					text-align: center;
				}
			}
			.fr {
				float: right;
			}
			.fl {
				float: left;
			}
		}
	}
	.sampleA_content_foot {
		max-width: 1600px;
		background-color: #fff;
		margin: auto;
		// padding-top: 50px;
		min-height: 550px;
		display: flex;
		justify-content: space-between;
		.sampleA_content_c {
			min-width: 200px;
			height: 42px;
			background-color: #0080ff;
			margin-left: 24px;
			border-radius: 0px 42px 42px 0px;
			line-height: 42px;
			color: #fff;
			font-size: 14px;
			padding-left: 5px;
			margin-top: 85px;
			position: relative;
			.sampleA_content_c_ass {
				position: absolute;
				top: 42px;
				left: 0px;
				width: 185px;
				height: 126px;
				overflow-y: auto;
				color: #333;
				p {
					padding-left: 10px;
					span {
						margin-left: 20px;
					}
				}
			}
		}
		.sampleA_content_d {
			margin: 0px 25px;
			flex: 1;
			width: 0;
			p {
				height: 85px;
				line-height: 85px;
				font-size: 16px;
				color: #333333;
				span {
					height: 16px;
					border: 3px solid #0080ff;
					border-radius: 8px;
					margin-right: 7px;
				}
			}
			.sampleA_content_d_table {
				.thead-cell > th {
					background-color: #f5f5f5;
					.cell {
						text-align: center;
					}
				}
				.el-table__row > td {
					text-align: center;
				}
			}
			.closebtn {
				float: right;
				margin-top: 20px;
				margin-bottom: 60px;
			}
		}
	}
	//  遮罩层
	.modalBox {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1001;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.3;
	}
	/*模态框*/
	.sampleMBox {
		position: fixed;
		background: #fff;
		width: 1200px;
		height: 746px;
		opacity: 1;
		z-index: 2001;
		top: 10%; /*偏移*/
		left: 50%;
		margin-left: -600px;
		p {
			height: 80px;
			line-height: 80px;
			display: flex;
			justify-content: space-between;
			span:nth-child(1) {
				margin-left: 26px;
			}
			span:nth-child(2) {
				margin-right: 50px;
			}
		}
		.sampleMBox_label {
			height: 490px;
			margin-left: 44px;
			display: flex;
			// flex-direction:row;
			flex-wrap: wrap; //是否换行
			justify-content: space-around;
			label {
				height: 34px;
				.el-input {
					width: 300px;
					height: 34px;
				}
			}
			// label:nth-child(odd) {
			// 	min-width: 650px;
			// }
			// label:nth-child(even) {
			// 	flex: 1;
			// }
			// label:nth-child(11),
			// label:nth-child(13) {
			// 	input {
			// 		width: 896px;
			// 		height: 76px;
			// 	}
			// }
		}
	}
	// 选中样式
	.pitch {
		background-color: #0080ff;
		color: #fff;
	}
}
</style>
